import { useEffect, useRef } from 'react';
import { SocialLinks } from './SocialLinks.jsx';
import { GridDistortion } from './GridDistortion.jsx';
import { manifestEntryFor, variantUrl } from '../lib/imageVariants.js';

// Build a CSS image-set() that lets the browser pick AVIF (smallest), then
// WebP, then the original JPG. Picks the largest variant available — the
// footer is full-bleed and we'd rather pay 200KB for a sharp render than
// half that for a softer one. The browser still skips loading entirely
// until the footer scrolls into view.
function backgroundFor(bgImage) {
  if (!bgImage) return null;
  const entry = manifestEntryFor(bgImage);
  if (!entry) return `url('${bgImage}')`;
  const w = entry.widths[entry.widths.length - 1];
  return (
    `image-set(` +
    `url('${variantUrl(entry.stem, w, 'avif')}') type('image/avif'),` +
    `url('${variantUrl(entry.stem, w, 'webp')}') type('image/webp'),` +
    `url('${bgImage}') type('image/jpeg')` +
    `)`
  );
}

export function Footer({ bgImage, children, bottomLeft, bottomRight, distortion = false }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && bgImage && !distortion) {
      ref.current.style.setProperty('--footer-img', backgroundFor(bgImage));
    }
  }, [bgImage, distortion]);

  return (
    <footer
      className={`site-footer${distortion ? ' site-footer--distortion' : ''}`}
      ref={ref}
      data-footer-img={bgImage}
    >
      {distortion && bgImage ? (
        <GridDistortion
          src={bgImage}
          heroRef={ref}
          grid={10}
          mouse={0.07}
          strength={0.06}
          relaxation={0.94}
          className="footer-distortion-bg"
          eager={false}
        />
      ) : null}
      <div className="footer-grid">{children}</div>
      <div className="footer-social">
        <SocialLinks />
      </div>
      <div className="footer-bottom">
        <span>{bottomLeft ?? <>© {new Date().getFullYear()} Zongheng Brian He</>}</span>
        <span>{bottomRight}</span>
      </div>
    </footer>
  );
}
